import React, { useEffect, useState, useCallback } from "react";
import "./SplashScreen.css";
import { useNavigate } from "react-router-dom";

const SplashScreen = () => {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);

  const closeSplash = useCallback(() => {
    setShowSplash(false);

    setTimeout(() => {
      navigate("/signin");
    }, 2000);
  }, [navigate]);

  useEffect(() => {
    if (showSplash) {
      document.addEventListener("click", closeSplash);
    } else {
      document.removeEventListener("click", closeSplash);
    }

    return () => {
      document.removeEventListener("click", closeSplash);
    };
  }, [showSplash, closeSplash]);

  useEffect(() => {
    const timer = setTimeout(() => {
      closeSplash();
    }, 2600);

    return () => clearTimeout(timer);
  }, [closeSplash]);

  return (
    <div className={`splash ${showSplash ? "" : "complete"}`}>
      <p>
        <span>A</span>
        <span>m</span>
        <span>i</span>
        <span>e</span>
      </p>
      {[...Array(10)].map((_, index) => (
        <div key={index}></div>
      ))}
    </div>
  );
};

export default SplashScreen;
